import {
  ZapIcon as DefaultIcon,
  DropletIcon,
  FlameIcon,
  HomeIcon,
  PhoneIcon,
  TrashIcon,
  TvIcon,
  WifiIcon,
  ZapIcon,
} from 'lucide-react';

import {
  UTILITIES_CONFIG,
  UTILITIES_KEYWORDS,
  VALID_UTILITIES_SUBCATEGORIES,
  detectUtilitiesSubcategory,
  detectUtilitiesSubcategoryWithConfidence,
} from '@splitfiesta/core';

export {
  UTILITIES_CONFIG,
  UTILITIES_KEYWORDS,
  VALID_UTILITIES_SUBCATEGORIES,
  detectUtilitiesSubcategory,
  detectUtilitiesSubcategoryWithConfidence,
};

type UtilitiesIcon = React.ComponentType<{ className?: string }>;

export const UTILITIES_SUBCATEGORY_ICONS: Record<string, UtilitiesIcon> = {
  electricity: ZapIcon,
  water: DropletIcon,
  gas: FlameIcon,
  internet: WifiIcon,
  phone: PhoneIcon,
  trash: TrashIcon,
  maintenance: HomeIcon,
  streaming: TvIcon,
  default: DefaultIcon,
};

export function getUtilitiesIcon(
  subcategory: string | null | undefined
): UtilitiesIcon {
  if (!subcategory || !(subcategory in UTILITIES_SUBCATEGORY_ICONS)) {
    return UTILITIES_SUBCATEGORY_ICONS.default;
  }
  return UTILITIES_SUBCATEGORY_ICONS[subcategory];
}
